import React, {useEffect, useState} from "react";
import {Line} from "react-chartjs-2";
import {
    Chart as ChartJS, LineElement, PointElement, CategoryScale, LinearScale, Tooltip, Legend,
} from "chart.js";

ChartJS.register(LineElement, PointElement, CategoryScale, LinearScale, Tooltip, Legend);

const emptyCharData = {
    labels: [" MHz"],
    datasets: [{
        label: "RF Signal", data: [], borderColor: "blue", // fallback color
        pointRadius: 0, borderWidth: 2, tension: 0.2, segment: {
            borderColor: "blue"
        }
    }]
}

function SDRViewer({spectrumData, freq}) {
    const [chartData, setChartData] = useState(emptyCharData);

    useEffect(() => {
        if (spectrumData?.freqs?.length && spectrumData?.amplitudes?.length) {
            const threshold = 20; // Set your amplitude threshold
            setChartData({
                labels: spectrumData.freqs.map((f) => (f / 1e6).toFixed(2) + " MHz"), datasets: [{
                    label: "RF Signal", data: spectrumData.amplitudes, borderColor: "blue", // fallback color
                    pointRadius: 0, borderWidth: 2, tension: 0.2, segment: {
                        borderColor: ctx => {
                            const i = ctx.p1DataIndex;
                            const amp = spectrumData.amplitudes[i];
                            return amp > threshold ? "green" : "blue";
                        }
                    }
                },],
            });
        }
    }, [spectrumData]);

    const options = {
        responsive: true, scales: {
            x: {
                type: "category", ticks: {
                    maxTicksLimit: 10,
                },
            }, y: {
                beginAtZero: true,
                min: 0,
                suggestedMax: 50,
                title: {
                    display: false, text: "Amplitude",
                },
            },
        }, plugins: {
            legend: {
                display: false,
            },
        },
    };

    return (<div>
        <h4 className={"text-center"}>Spectrum Analyzer @ {freq} MHz</h4>
        <Line data={chartData} options={options}/>
    </div>);
}

export default SDRViewer;
